export enum MACHINE_STATUS {
  UNKNOWN = 'UNKNOWN',
  RUNNING = 'RUNNING',
  STOPPED = 'STOPPED',
  STOPPED_BEFORE = 'STOPPED_BEFORE',
  DISCONNECTED = 'DISCONNECTED',
  CANNOTEVALUATE = 'CANNOTEVALUATE',
  OFFLINE = 'OFFLINE',
}
